import React, { useState, useEffect } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate, Link } from "react-router-dom";
import {
  validateMobileNumber10Digits,
  validateAlphabetsAndSpace,
} from "../../Helper/common";

import PVRadio from "./pvRadio";
import PVText from "./pvText";
import PVRefText from "./pvRefText";
import PVCheckbox from "./pvCheckbox";
import PVDate from "./pvDate";
import PVSelect from "./pvSelect";
import PVRefSelect from "./pvRefSelect";
import PVSelectState from "./pvSelectState";

import PVSingleFileUpload from "./pvSingleFileUpload";
import {
  savePv,
  deletePv,
  updatePv,
  deleteUpdatePv,
} from "../../Actions/pvActions";
import { getPincode } from "../../Actions/pincodeAction";
import DownloadIcon from "../../assets/img/download-icon-black.svg";
import { validatePincode } from "../../Helper/common";
// import PVSelect from "./pvSelect";

const MainForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pvData, active, countries, state, relationOption, continueButton } =
    props;
  const [loading, setLoading] = useState(false);
  const [pv, setPv] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [errorDataCustom, setErrorDataCustom] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [isIndia, setIsIndia] = useState([]);
  const [isSsn, setIsSsn] = useState([]);
  const [tillDateChecked, setTillDateChecked] = useState({ 0: false });
  const storeData = useSelector((state) => state.pvSaveData);
  const { pvSaveData, loading: pvSaveDataLoading } = storeData;
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [uploadedFilesCountField, setUploadedFilesCountField] = useState({});
  const [noSsnChecked, setNoSsn] = useState({});

  const [refRecord, setRefRecord] = useState({});

  const [currentField, setCurrentField] = useState(null);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    setPv(pvData);
  }, [pvData]);

  // const [stateList, setStateList] = useState([]);

  // useEffect(() => {
  //   if (countries?.length) {
  //     setStateList(state)
  //   }
  // }, [state])

  useEffect(() => {
    if (typeof pvSaveData.data !== "undefined" && pvSaveData.data !== null) {
      const group = pvSaveData.data.group ? pvSaveData.data.group.group_id : "";
      const reference = pvSaveData.data.reference_number;
      if (group == "profile_preview") {
        navigate(`/case-initiation/profile-preview/${reference}`);
        dispatch(deletePv());
      } else if (typeof group != "undefined" && group != "") {
        navigate(`/case-initiation/check-detail/${reference}/${group}`);
        dispatch(deletePv());
      }
    }
  }, [pvSaveData]);

  const pvUpdateStoreData = useSelector((state) => state.pvUpdate);
  const { pvUpdateData, loading: pvUpdateDataLoading } = pvUpdateStoreData;

  useEffect(() => {
    if (
      typeof pvUpdateData !== "undefined" &&
      pvUpdateData !== null &&
      Object.keys(pvUpdateData).length !== 0
    ) {
      console.log("dfd", pvUpdateData);

      // errorArr['aff'] = false;

      props.reRenderAgainUpdate();

      // const group = pvSaveData.data.group ? pvSaveData.data.group.group_id : '';
      // const reference = pvSaveData.data.reference_number;
      // if (group == 'profile_preview') {
      //   navigate(
      //     `/case-initiation/profile-preview/${reference}`
      //   );
      //   dispatch(deletePv());
      // } else if (typeof group != "undefined" && group != '') {
      //   navigate(
      //     `/case-initiation/check-detail/${reference}/${group}`
      //   );
      //   dispatch(deleteUpdatePv());
      // }
    }
  }, [pvUpdateData]);

  useEffect(() => {
    if (
      typeof pvData.checksDetails !== "undefined" &&
      pvData.checksDetails !== null
    ) {
      const checksDetails = pvData.checksDetails;
      // const india = checksDetails[0].fields.address_belongs_to.field_value === "Within India" || checksDetails[0].fields.address_belongs_to.field_value === '' ? true : false;
      // let updatedIndia = _.cloneDeep(isIndia);
      // updatedIndia[0] = india;
      // setIsIndia(updatedIndia);
      // const ssn = checksDetails[0].fields.country.field_value == 2 ? true : false;
      // let updatedSsn = _.cloneDeep(ssn);
      // updatedSsn = ssn;
      // setIsSsn(updatedSsn);
      // getUploadedFilesCount(checksDetails);
      // setDateConditions(checksDetails);
      let obj = {};
      let errorArr = [];
      for (var j in checksDetails[0].fields) {
        if (
          j === "pin_code" &&
          checksDetails[0].fields[j].field_value !== "" &&
          checksDetails[0].fields[j].field_value !== null
        ) {
          let valid = validatePincode(checksDetails[0].fields[j].field_value);
          errorArr[j] = !valid;
        } else {
          errorArr[j] = false;
        }

        // let fieldName = selectValues.dataset.fieldname;

        //  alert(JSON.stringify(selectValues))

        if (j === "pv_id_proof") {
          let pvDetails = _.cloneDeep(pvData);
          // let val = pvDetails.checksDetails[activeTab - 1].fields['pv_id_proof'].field_value;

          setSelectedIdProof(checksDetails[0].fields[j].field_value);
          setSelectedIdProofField(checksDetails[0].fields[j].ibridge_field_id);
          //alert(selectedIdProof)

          // let pinArr = [];
          // pinArr[0] = textValues;
          // dispatch(getPincode(pinArr));
        }

        if (j === "pv_address_proof") {
          setSelectedAddressProof(checksDetails[0].fields[j].field_value);
          setSelectedAddressProofField(
            checksDetails[0].fields[j].ibridge_field_id
          );
        }
      }

      errorArr = Object.assign({}, errorData);

      // console.log("here",errorArr);
      // debugger;

      if (errorData["id_proof_front"] === true) {
        errorArr["id_proof_front"] = true;
      } else {
        errorArr["id_proof_front"] = false;
      }

      if (errorData["id_proof_back"] === true) {
        errorArr["id_proof_back"] = true;
      } else {
        errorArr["id_proof_back"] = false;
      }

      if (currentField == "id_proof_front") {
        errorArr["id_proof_front"] = false;
      }

      if (currentField == "id_proof_back") {
        errorArr["id_proof_back"] = false;
      }

      if (errorData["address_proof_front"] === true) {
        errorArr["address_proof_front"] = true;
      } else {
        errorArr["address_proof_front"] = false;
      }

      if (errorData["address_proof_back"] === true) {
        errorArr["address_proof_back"] = true;
      } else {
        errorArr["address_proof_back"] = false;
      }

      if (currentField == "address_proof_back") {
        errorArr["address_proof_back"] = false;
      }

      if (currentField == "address_proof_front") {
        errorArr["address_proof_front"] = false;
      }

      if (errorData["photograph_uploader"] === true) {
        errorArr["photograph_uploader"] = true;
      } else {
        errorArr["photograph_uploader"] = false;
      }

      if (currentField == "photograph_uploader") {
        errorArr["photograph_uploader"] = false;
      }

      if (errorData["affidavit_uploader"] === true) {
        errorArr["affidavit_uploader"] = true;
      } else {
        errorArr["affidavit_uploader"] = false;
      }

      if (currentField == "affidavit_uploader") {
        errorArr["affidavit_uploader"] = false;
      }

      if (errorData["pv"] === true) {
        errorArr["pv"] = true;
      } else {
        errorArr["pv"] = false;
      }

      if (currentField == "pv") {
        errorArr["pv"] = false;
      }

      if (errorData["cl"] === true) {
        errorArr["cl"] = true;
      } else {
        errorArr["cl"] = false;
      }

      if (currentField == "cl") {
        errorArr["cl"] = false;
      }

      // console.log("here", errorArr);
      // debugger;

      if (Object.keys(unsavedErrorData).length == 0) {
        // alert("fd");
        setErrorData(errorArr);
      } else {
        // debugger;

        const newErr = Object.assign({}, errorData);
        if (currentField != "pin_code") {
          newErr[currentField] = false;
        }

        setErrorData(newErr);
      }
    }
  }, [pvData]);

  useEffect(() => {
    setLoading(props.isLoading);
  }, [props.isLoading]);

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    if (dataset.fieldname === "address_belongs_to") {
      const india = value === "Within India" ? true : false;
      let updatedIndia = _.cloneDeep(isIndia);
      updatedIndia[parseInt(dataset.checkdetailsindex)] = india;
      setIsIndia(updatedIndia);
    }
    updatePvDetails(dataset, value);
  };

  const [selectedIdProof, setSelectedIdProof] = useState(null);
  const [selectedIdProofField, setSelectedIdProofField] = useState(null);
  const [selectedAddressProof, setSelectedAddressProof] = useState(null);
  const [selectedAddressProofField, setSelectedAddressProofField] =
    useState(null);

  const handleSelectChange = (selectValues) => {
    const { dataset, value } = selectValues;
    let errId = selectValues.dataset.err;

    setCurrentField(dataset.fieldname);

    handleErrorData(dataset.fieldname, value != "" ? false : true);
    //  console.log("see",selectValues);
    // var cols = document.getElementById(errId);
    // cols.innerHTML = '';

    // let errId = selectValues.dataset.err;

    // var cols = document.getElementById(errId);
    // cols.innerHTML = '';

    let fieldName = selectValues.dataset.fieldname;

    //  alert(JSON.stringify(selectValues))

    if (fieldName === "pv_id_proof") {
      let pvDetails = _.cloneDeep(pvData);
      // let val = pvDetails.checksDetails[activeTab - 1].fields['pv_id_proof'].field_value;

      setSelectedIdProof(value);
      setSelectedIdProofField(dataset.ibfieldid);
      // alert(selectedIdProofField)

      // let pinArr = [];
      // pinArr[0] = textValues;
      // dispatch(getPincode(pinArr));
    }

    if (fieldName === "pv_address_proof") {
      setSelectedAddressProof(value);
      setSelectedAddressProofField(dataset.ibfieldid);
    }

    console.log(dataset);
    // const ssn = value == 2 ? true : false;
    // let updatedSsn = _.cloneDeep(ssn);
    // updatedSsn = ssn;
    // setIsSsn(updatedSsn);

    //alert(dataset)

    updatePvDetails(dataset, value);
  };

  const [unsavedErrorData, setUnsavedErrorData] = useState({});

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;

    setCurrentField(dataset.fieldname);

    let errId = textValues.dataset.err;
    // var cols = document.getElementById(errId);
    // cols.innerHTML = '';

    let fieldName = textValues.dataset.fieldname;
    if (fieldName === "pin_code") {
      let pinArr = [];
      pinArr[0] = textValues;
      let valid = validatePincode(pinArr[0].value);
      if (valid) {
        dispatch(getPincode(pinArr));
      } else {
        let errorArrCustom = [];

        errorArrCustom["pin"] = "Please provide valid input.";
        setErrorDataCustom(errorArrCustom);
      }

      const updatedErrorData = Object.assign({}, errorData);
      updatedErrorData["pin_code"] = !valid;
      // updatedErrorData['city'] = !valid;
      // updatedErrorData['location'] = !valid;
      setErrorData(updatedErrorData);
      setUnsavedErrorData(updatedErrorData);
      //  dispatch(getPincode(pinArr));
    } else {
      handleErrorData(dataset.fieldname, value != "" ? false : true);
    }

    updatePvDetails(dataset, value);
  };

  const handleErrorData = (field, val) => {
    let newData = Object.assign({}, errorData);
    newData[field] = val;
    setErrorData(newData);
    setUnsavedErrorData(newData);
  };

  //const replaceItemAtIndex =  [...arr.slice(0, index), newValue, ...arr.slice(index + 1)];

  const handleRefChange = (textValues) => {
    const { dataset, value } = textValues;

    //`ref_Address_${[i + 1]}`
    let fieldName = textValues.dataset.fieldname;
    let index = textValues.dataset.checkdetailsindex;
    let errId = textValues.dataset.err;

    let errorArrCustom = [];

    // alert("ref_" + process(fieldName) + "_" + index);

    setCurrentField("ref_" + process(fieldName) + "_" + index);

    //  console.log("see", errId);

    // var cols = document.getElementById(errId);
    // cols.innerHTML = '';

    //let value = textValues.value;

    console.log("hel", value);
    console.log("hel", value, fieldName);
    //setCustomFieldsDataArr

    // debugger;
    //return false;

    if (fieldName == "Address" && value != "") {
      // setErrorData(false);
    }

    let xz = _.cloneDeep(customFieldsDataArr);

    let exr = _.cloneDeep(customFieldsDataArr[index]);

    exr[fieldName].value = value;
    xz[index] = exr;
    // console.log("x", fieldName)

    console.log("x", exr);

    setCustomFieldsDataArr(xz);

    // console.log("fff", customFieldsDataArr);

    handleErrorData(
      "ref_" + process(fieldName) + "_" + index,
      value != "" ? false : true
    );

    const updatedErrorDataC = Object.assign({}, errorDataCustom);
    /// updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isMobValid;
    setErrorDataCustom(updatedErrorDataC);

    if (fieldName == "Mob No." && value != "") {
      let isMobValid = validateMobileNumber10Digits(value);
      if (!isMobValid) {
        updatedErrorDataC["ref_" + process(fieldName) + "_" + index] =
          "Please provide valid input.";

        const updatedErrorData = Object.assign({}, errorData);
        updatedErrorData["ref_" + process(fieldName) + "_" + index] =
          !isMobValid;
        setErrorData(updatedErrorData);
      }

      setErrorDataCustom(updatedErrorDataC);
    }

    if (fieldName == "Name" && value != "") {
      let isNameValid = validateAlphabetsAndSpace(value);
      if (!isNameValid) {
        updatedErrorDataC["ref_" + process(fieldName) + "_" + index] =
          "Please provide valid input.";
        const updatedErrorData = Object.assign({}, errorData);
        updatedErrorData["ref_" + process(fieldName) + "_" + index] =
          !isNameValid;
        setErrorData(updatedErrorData);
      }

      setErrorDataCustom(updatedErrorDataC);
    }

    //  setCustomFieldsDataArr((prevState) => ({
    //     ...prevState,
    //     [index]: {
    //       ...prevState.index,
    //       [fieldName]: { value: value, label: fieldName }
    //     }
    //   }));

    // setRefRecord((prevState) => ({
    //   ...prevState,
    //   [index]: {
    //     ...prevState.index,
    //     [fieldName]: { value: value, label: fieldName }
    //   }
    // }));

    // console.log("ref", customFieldsDataArr)

    //  pvDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
    //   dataset.fieldname
    // ].field_value = value;
    // console.log(index);

    // if (fieldName === 'pin_code') {
    //   let pinArr = [];
    //   pinArr[0] = textValues;
    //   dispatch(getPincode(pinArr));
    // }
    // const { dataset, value } = textValues;
    // updatePvDetails(dataset, value);

    //s  updatePvRefDetails(customFieldsDataArr);
  };

  // const updatePvRefDetails = (arr) => {
  //   let pvDetails = _.cloneDeep(pv);
  //   pvDetails.checksDetails[0].customFieldsDataArr.reference = arr;

  //   console.log("s",pvDetails)
  // //  setPv(pvDetails);
  // };

  const storePincodeData = useSelector((state) => state.pincode);
  const { pincodeData } = storePincodeData;
  useEffect(() => {
    if (typeof pv.checksDetails !== "undefined" && pv.checksDetails !== null) {
      if (
        typeof pincodeData.data !== "undefined" &&
        pincodeData.data !== null
      ) {
        let pvDetails = _.cloneDeep(pv);
        pvDetails.checksDetails[0].fields["city"].field_value =
          pincodeData.data.city_name;
        pvDetails.checksDetails[0].fields["location"].field_value =
          pincodeData.data.state_id;

        /////
        let caseCheckId = pvDetails.checksDetails[0].case_check_id;
        let stateverificationsrc = document.getElementById(
          "stateverificationsrc_" + caseCheckId
        );
        let stateverificationsrclabel = document.getElementById(
          "stateverificationsrclabel_" + caseCheckId
        );

        stateverificationsrc.value = pincodeData.data.state_id;
        stateverificationsrclabel.value = pincodeData.data.state_name;
        ////

        setPv(pvDetails);
      }
    }
  }, [pincodeData, storePincodeData]);

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset, value } = checkboxValues;
    if (dataset.fieldname === "till_date") {
      let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
      const updatedValue =
        updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
          ? ""
          : "checked";

      updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] =
        !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
      setTillDateChecked(updatedTillDateChecked);
      // console.log(tillDateChecked);
      updatePvDetails(dataset, updatedValue);
    }

    if (dataset.fieldname === "no_ssn") {
      let updatedNoSsn = _.cloneDeep(noSsnChecked);
      const updatedValue =
        updatedNoSsn[parseInt(dataset.checkdetailsindex)] === true
          ? ""
          : "checked";

      updatedNoSsn[parseInt(dataset.checkdetailsindex)] =
        !updatedNoSsn[parseInt(dataset.checkdetailsindex)];
      setNoSsn(updatedNoSsn);
      let pvDetails = _.cloneDeep(pv);
      pvDetails.checksDetails[0].fields["ssn"].is_mandatory = 0;
      setPv(pvDetails);
    }
  };

  const handleSaveDate = (checkDetailsIndex, fieldName, savedDate) => {
    setCurrentField(fieldName);
    // const unsavedData = Object.assign({} , errorData);
    // setUnsavedErrorData(unsavedData);
    handleErrorData(fieldName, false);
    let updatedScotDetails = _.cloneDeep(pv);
    for (var i in updatedScotDetails.checksDetails[parseInt(checkDetailsIndex)]
      .fields) {
      if (i == fieldName) {
        updatedScotDetails.checksDetails[parseInt(checkDetailsIndex)].fields[
          i
        ].field_value = savedDate;
      }
    }
    setPv(updatedScotDetails);
  };

  const updatePvDetails = (dataset, value) => {
    let pvDetails = _.cloneDeep(pv);
    pvDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].field_value = value;
    setPv(pvDetails);
  };

  const saveHandler = async (e, caseCheckId, index) => {
    props.setIsLoading(true);
    e.preventDefault();
    let hasError = false;
    setErrorData([]);

    let errorArr = [];
    let errorArrCustom = [];

    if (typeof pv.checksDetails !== "undefined" && pv.checksDetails !== null) {
      const checksDetails = pv.checksDetails;
      for (var j in checksDetails[0].fields) {
        const fieldArr = [49, 210];
        if (isSsn === true) {
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            hasError = true;
            errorArr[j] = true;
          } else {
            errorArr[j] = false;
          }
        } else {
          if (
            checksDetails[0].fields[j].ibridge_field_id == 50 &&
            tillDateChecked[0] === true
          ) {
            errorArr[j] = false;
            continue;
          }

          // alert("s")
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            if (
              fieldArr.includes(checksDetails[0].fields[j].ibridge_field_id)
            ) {
              errorArr[j] = false;
            } else {
              hasError = true;
              errorArr[j] = true;
            }
            // alert(checksDetails[0].fields[j].field_value);
          } else {
            if (j === "pin_code") {
              let valid = validatePincode(
                checksDetails[0].fields[j].field_value
              );

              if (valid === false) {
                hasError = true;
                errorArrCustom["pin"] = "Please provide valid input.";
              }
              errorArr[j] = !valid;
            } else {
              errorArr[j] = false;
            }
          }
        }
      }

      //id_proof validations

      console.log("tt", letterRequired);
      console.log("tts", checksDetails[0].fields.pv_request_letter.is_mandatory);
      // debugger;

      if (selectedIdProof !== "") {
        let isRequired =
          docmentTypeOptionsMand[parseInt(index - 1)] &&
            docmentTypeOptionsMand[parseInt(index - 1)][selectedIdProof]
            ? docmentTypeOptionsMand[parseInt(index - 1)][selectedIdProof]
            : 0;

        // alert(isRequired)

        if (isRequired) {
          let backCount =
            uploadedFilesCountField[parseInt(index - 1)] &&
              uploadedFilesCountField[parseInt(index - 1)].length !== 0 &&
              uploadedFilesCountField[parseInt(index - 1)].hasOwnProperty(
                selectedIdProofField
              ) &&
              uploadedFilesCountField[parseInt(index - 1)][selectedIdProofField][
              35
              ]
              ? uploadedFilesCountField[parseInt(index - 1)][
              selectedIdProofField
              ][35]["back"]
              : 0;

              console.log("ttb", backCount);

          let frontCount =
            uploadedFilesCountField[parseInt(index - 1)] &&
              uploadedFilesCountField[parseInt(index - 1)].length !== 0 &&
              uploadedFilesCountField[parseInt(index - 1)].hasOwnProperty(
                selectedIdProofField
              ) &&
              uploadedFilesCountField[parseInt(index - 1)][selectedIdProofField][
              35
              ]
              ? uploadedFilesCountField[parseInt(index - 1)][
              selectedIdProofField
              ][35]["front"]
              : 0;

          if (backCount === 0) {
            hasError = true;
            errorArr["id_proof_back"] = true;
          } else {
            errorArr["id_proof_back"] = false;
          }
          if (frontCount === 0) {
            hasError = true;
            errorArr["id_proof_front"] = true;
          } else {
            errorArr["id_proof_front"] = false;
          }

          //id_proof validations

          //checking count
        }
      }

      if (selectedAddressProof !== "") {
        let isRequired =
          docmentTypeAddressOptionsMand[parseInt(index - 1)] &&
            docmentTypeAddressOptionsMand[parseInt(index - 1)][
            selectedAddressProof
            ]
            ? docmentTypeAddressOptionsMand[parseInt(index - 1)][
            selectedAddressProof
            ]
            : 0;

        // alert(isRequired)

        if (isRequired) {
          let backCount =
            uploadedFilesCountField[parseInt(index - 1)] &&
              uploadedFilesCountField[parseInt(index - 1)].length !== 0 &&
              uploadedFilesCountField[parseInt(index - 1)].hasOwnProperty(
                selectedAddressProofField
              ) &&
              uploadedFilesCountField[parseInt(index - 1)][
              selectedAddressProofField
              ][34]
              ? uploadedFilesCountField[parseInt(index - 1)][
              selectedAddressProofField
              ][34]["back"]
              : 0;

          let frontCount =
            uploadedFilesCountField[parseInt(index - 1)] &&
              uploadedFilesCountField[parseInt(index - 1)].length !== 0 &&
              uploadedFilesCountField[parseInt(index - 1)].hasOwnProperty(
                selectedAddressProofField
              ) &&
              uploadedFilesCountField[parseInt(index - 1)][
              selectedAddressProofField
              ][34]
              ? uploadedFilesCountField[parseInt(index - 1)][
              selectedAddressProofField
              ][34]["front"]
              : 0;

          console.log("tt1", selectedAddressProofField);

          if (selectedAddressProof != "2" && selectedAddressProof != "127") {
            if (backCount === 0) {
              hasError = true;
              errorArr["address_proof_back"] = true;
            } else {
              errorArr["address_proof_back"] = false;
            }
          }

          if (frontCount === 0) {
            hasError = true;
            errorArr["address_proof_front"] = true;
          } else {
            errorArr["address_proof_front"] = false;
          }

          //id_proof validations

          //checking count
        }
      }

      //debugger;

      if (pvformRequired == 1) {
        let frontCount =
          uploadedFilesCount[parseInt(index - 1)] &&
            uploadedFilesCount[parseInt(index - 1)][32]
            ? uploadedFilesCount[parseInt(index - 1)][32]["front"]
            : 0;

        if (frontCount == 0) {
          hasError = true;
          errorArr["pv"] = true;
        } else {
          errorArr["pv"] = false;
        }
      }

      if (letterRequired == 1 && checksDetails[0].fields.pv_request_letter.is_mandatory ===  1) {
        let frontCount =
          uploadedFilesCount[parseInt(index - 1)] &&
            uploadedFilesCount[parseInt(index - 1)][33]
            ? uploadedFilesCount[parseInt(index - 1)][33]["front"]
            : 0;

        if (frontCount == 0) {
          hasError = true;
          errorArr["cl"] = true;
        } else {
          errorArr["cl"] = false;
        }
      }

      if (photoRequired == 1) {
        let frontCount =
          uploadedFilesCount[parseInt(index - 1)] &&
            uploadedFilesCount[parseInt(index - 1)][36]
            ? uploadedFilesCount[parseInt(index - 1)][36]["front"]
            : 0;

        if (frontCount == 0) {
          hasError = true;
          errorArr["photograph_uploader"] = true;
        } else {
          errorArr["photograph_uploader"] = false;
        }
      }

      if (affidavitRequired == 1) {
        let frontCount =
          uploadedFilesCount[parseInt(index - 1)] &&
            uploadedFilesCount[parseInt(index - 1)][38]
            ? uploadedFilesCount[parseInt(index - 1)][38]["front"]
            : 0;

        if (frontCount == 0) {
          hasError = true;
          errorArr["affidavit_uploader"] = true;
        } else {
          errorArr["affidavit_uploader"] = false;
        }
      }

      // // Validation for upload document
      // if(checksDetails[0].required_documents[0] && checksDetails[0].required_documents[0].is_mandatory == 1){
      //   if(checksDetails[0].uploaded_documents && checksDetails[0].uploaded_documents[0]){
      //     hasError = hasError ? hasError : false;
      //     errorArr["upload_document"] = false;
      // }else{
      //     hasError = true;
      //     errorArr["upload_document"] = true;
      // }
      // }else{
      //   hasError = true;
      //   errorArr["upload_document"] = true;
      // }

      console.log("ffg");

      // if (fieldName == "Mob No." && value != "") {

      //   let isMobValid = validateMobileNumber10Digits(value);
      //   if (!isMobValid) {
      //     errorArrCustom["ref_" + process(fieldName) + "_" + index] = "Please provide valid input.";
      //     const updatedErrorData = Object.assign({}, errorData);
      //     updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isMobValid;
      //     setErrorData(updatedErrorData);
      //   }

      //   setErrorDataCustom(errorArrCustom);
      // }

      // if (fieldName == "Name" && value != "") {

      //   let isNameValid = validateAlphabetsAndSpace(value);
      //   if (!isNameValid) {
      //     errorArrCustom["ref_" + process(fieldName) + "_" + index] = "Please provide valid input.";
      //     const updatedErrorData = Object.assign({}, errorData);
      //     updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isNameValid;
      //     setErrorData(updatedErrorData);
      //   }

      //   setErrorDataCustom(errorArrCustom);
      // }

      const updatedErrorDataC = Object.assign({}, errorDataCustom);
      /// updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isMobValid;
      setErrorDataCustom(updatedErrorDataC);

      if (referenceRequired == 1) {
        for (var x in customFieldsDataArr) {
          for (var u in customFieldsDataArr[x]) {
            console.log("lab", customFieldsDataArr[x][u].label);

            let label = customFieldsDataArr[x][u].label;

            if (
              customFieldsDataArr[x][u].value.trim() === "" ||
              customFieldsDataArr[x][u].value == null
            ) {
              hasError = true;
              // console.log("look", customFieldsDataArr[x][u], "cfffddf", x, "dgfdg", u);
              errorArr[
                "ref_" + process(customFieldsDataArr[x][u].label) + "_" + x
              ] = true;
            } else {
              //hasError = false;
              errorArr[
                "ref_" + process(customFieldsDataArr[x][u].label) + "_" + x
              ] = false;

              if (label == "Mob No.") {
                let isMobValid = validateMobileNumber10Digits(
                  customFieldsDataArr[x][u].value
                );
                if (!isMobValid) {
                  updatedErrorDataC[
                    "ref_" +
                    process(customFieldsDataArr[x][u].label) +
                    "_" +
                    index
                  ] = "Please provide valid input.";
                  // const updatedErrorData = Object.assign({}, errorData);
                  // updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isMobValid;
                  // setErrorData(updatedErrorData);
                  hasError = true;
                  errorArr[
                    "ref_" + process(customFieldsDataArr[x][u].label) + "_" + x
                  ] = true;
                }
              }

              if (label == "Name") {
                let isNameValid = validateAlphabetsAndSpace(
                  customFieldsDataArr[x][u].value
                );
                if (!isNameValid) {
                  updatedErrorDataC[
                    "ref_" +
                    process(customFieldsDataArr[x][u].label) +
                    "_" +
                    index
                  ] = "Please provide valid input.";
                  // const updatedErrorData = Object.assign({}, errorData);
                  // updatedErrorData["ref_" + process(fieldName) + "_" + index] = !isMobValid;
                  // setErrorData(updatedErrorData);
                  hasError = true;
                  errorArr[
                    "ref_" + process(customFieldsDataArr[x][u].label) + "_" + x
                  ] = true;
                }
              }

              setErrorDataCustom(updatedErrorDataC);

              //    console.log("look", customFieldsDataArr[x][u], "cfffddf", x, "dgfdg", u);
            }
          }
        }
      }
    }

    // debugger;

    //setting error for references

    // debugger;

    // props.setIsLoading(false);
    // console.log("namo",errorArr, );
    // return false;

    setErrorData(errorArr);

    // debugger;

    //alert("d"); return false;

    console.log("fg", errorData);

    if (hasError == true) {
      props.setIsLoading(false);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      savePvDetails(index - 1, caseCheckId);
    }
  };

  function process(value) {
    return value == undefined
      ? ""
      : value
        .replace(/[^a-z0-9_]+/gi, "-")
        .replace(/^-|-$/g, "")
        .toLowerCase();
  }

  const savePvDetails = (checksDetailsIndex, caseCheckId) => {
    let savedDetailsObj = {};
    const fieldDetails = _.cloneDeep(
      pv.checksDetails[checksDetailsIndex].fields
    );
    savedDetailsObj["group"] = "pv";

    let stateverificationsrc = document.getElementById(
      "stateverificationsrc_" + caseCheckId
    );
    let stateverificationsrclabel = document.getElementById(
      "stateverificationsrclabel_" + caseCheckId
    );

    savedDetailsObj["stateverificationsrc"] = stateverificationsrc.value;
    savedDetailsObj["stateverificationsrcLabel"] =
      stateverificationsrclabel.value;

    savedDetailsObj["reference"] = customFieldsDataArr;

    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value;
      }
    }
    props.setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    dispatch(savePv(caseCheckId, finalData, activeTab));
  };

  const updateHandler = async (e, caseCheckId, index) => {
    props.setIsLoading(true);
    e.preventDefault();
    let hasError = false;
    let errorArr = [];
    let errorArrCustom = [];
    if (typeof pv.checksDetails !== "undefined" && pv.checksDetails !== null) {
      const checksDetails = pv.checksDetails;
      for (var j in checksDetails[0].fields) {
        const fieldArr = [49, 139, 141];
        if (isSsn === true) {
          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            hasError = true;
            errorArr[j] = true;
          } else {
            errorArr[j] = false;
          }
        } else {
          // alert(JSON.stringify(checksDetails[0].fields[j]))

          //condition for validation on residing to field based on till date checked

          if (
            checksDetails[0].fields[j].ibridge_field_id == 50 &&
            tillDateChecked[0] === true
          ) {
            errorArr[j] = false;
            continue;
          }

          if (
            checksDetails[0].fields[j].is_mandatory == 1 &&
            (checksDetails[0].fields[j].field_value == "" ||
              checksDetails[0].fields[j].field_value == null)
          ) {
            if (
              fieldArr.includes(checksDetails[0].fields[j].ibridge_field_id)
            ) {
              errorArr[j] = false;
            } else {
              hasError = true;
              errorArr[j] = true;
            }
          } else {
            if (j === "pin_code") {
              let valid = validatePincode(
                checksDetails[0].fields[j].field_value
              );

              if (valid === false) {
                hasError = true;
                errorArrCustom["pin"] = "Please provide valid input.";
              }
              errorArr[j] = !valid;
            } else {
              errorArr[j] = false;
            }
          }
        }
      }
    }

    console.log("dum", errorArrCustom, hasError);
    setErrorDataCustom(errorArrCustom);
    setErrorData(errorArr);

    // debugger;
    if (hasError == true) {
      props.setIsLoading(false);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      updateActionPvDetails(index - 1, caseCheckId);
    }
  };

  const updateActionPvDetails = (checksDetailsIndex, caseCheckId) => {
    let savedDetailsObj = {};
    const fieldDetails = _.cloneDeep(
      pv.checksDetails[checksDetailsIndex].fields
    );

    savedDetailsObj["group"] = "pv";

    //savedDetailsObj['cityverificationsrc'] = 'pv';
    let stateverificationsrc = document.getElementById(
      "stateverificationsrc_" + caseCheckId
    );
    let stateverificationsrclabel = document.getElementById(
      "stateverificationsrclabel_" + caseCheckId
    );
    savedDetailsObj["stateverificationsrc"] = stateverificationsrc.value;
    savedDetailsObj["stateverificationsrcLabel"] =
      stateverificationsrclabel.value;

    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value;
      }
    }
    //   props.setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;

    console.log("dr", finalData);
    dispatch(updatePv(caseCheckId, finalData, activeTab));
    props.setIsLoading(false);
  };

  //setting loader while saving
  // const storePvUpdate = useSelector((state) => state.pvUpdate);
  // const { pvUpdateData, loading: saveLoading, error: saveError } = storePvUpdate;
  // console.log(educationSaveData);
  // useEffect(() => {
  //   if (typeof saveLoading !== "undefined" && saveLoading !== null) {
  //     if (saveLoading === true) {
  //       setIsLoading(true);
  //     } else {
  //       setIsLoading(false);
  //     //  reRenderAgain();
  //     }

  //   }
  // }, [saveLoading]);

  const getUpdatedPvDataUp = (fn) => {
    //sadfdds

    setCurrentField(fn);
    props.reRenderAgain2(pv);
    //  reRenderAgain();
  };

  const getUpdatedPvData = () => {
    //  dfgfdg

    reRenderAgain();
  };

  const reRenderAgain = () => {
    props.reRenderAgain();
  };

  const reRenderAgain2 = () => {
    props.reRenderAgain2(pv);
  };

  const [docmentTypeOptions, setDocmentTypeOptions] = useState({});
  const [docmentTypeAddressOptions, setDocmentTypeAddressOptions] = useState(
    {}
  );

  const [docmentTypeOptionsMand, setDocmentTypeOptionsMand] = useState({});
  const [docmentTypeAddressOptionsMand, setDocmentTypeAddressOptionsMand] =
    useState({});

  const [pvformRequired, setPvformRequired] = useState({});
  const [idRequired, setIdRequired] = useState({});
  const [addressproofRequired, setAddressproofRequired] = useState({});
  const [photoRequired, setPhotoRequired] = useState({});
  const [letterRequired, setLetterRequired] = useState({});
  const [affidavitRequired, setAffidavitrequired] = useState({});

  const [referenceRequired, setReferenceRequired] = useState({});
  const [referenceCount, setReferenceCount] = useState({});
  const [referenceConf, setReferenceConf] = useState({});
  const [customFieldsDataArr, setCustomFieldsDataArr] = useState([]);

  useEffect(() => {
    if (typeof pv.checksDetails !== "undefined" && pv.checksDetails !== null) {
      const checksDetails = pv.checksDetails;
      let docmentTypeData = {};
      let docmentTypeAddressData = {};
      if (
        typeof checksDetails[0].apiData !== "undefined" &&
        checksDetails[0].apiData !== null
      ) {
        const apiData = checksDetails[0].apiData;

        docmentTypeData = apiData.ID_PROOF_DTLS;
        docmentTypeAddressData = apiData.ADDRESS_PROOF_DTLS;

        let refCount = apiData.REFERENCE_COUNT;
        if (refCount < 1) {
          refCount = 1;
        }
        let refRequired = apiData.IS_REFERENCE_DETAILS_REQUIRED;
        let refConf = apiData.REFERENCE_DETAILS_CONFS;

        let pvformRequired = apiData.PV_FORM_REQUIRED;
        let idRequired = apiData.IS_ID_PROOF_REQUIRED;
        let addressproofRequired = apiData.IS_ADDRESS_PROOF_REQUIRED;
        let photoRequired = apiData.IS_PHOTO_REQUIRED;
        let letterRequired = apiData.IS_COMPANY_REQUIRED_LETTER;
        let affidavitRequired = apiData.IS_AFFIDAVIT_REQUIRED;

        setPvformRequired(pvformRequired);
        setIdRequired(idRequired);
        setAddressproofRequired(addressproofRequired);
        setPhotoRequired(photoRequired);
        setLetterRequired(letterRequired);
        setAffidavitrequired(affidavitRequired);

        setReferenceRequired(refRequired);
        setReferenceCount(refCount);
        setReferenceConf(refConf);

        let mainobj = {};

        if (
          JSON.stringify(checksDetails[0].customFieldsDataArr) == "[]" &&
          JSON.stringify(customFieldsDataArr) == "[]"
        ) {
          let objc = {};
          for (let i = 0; i < refCount; i++) {
            {
              refConf &&
                Object.values(refConf).map((key, valp) => {
                  objc[`${key}`] = { value: "", label: key };
                });
            }

            mainobj[i + 1] = objc;
          }

          console.log("s", mainobj);

          // setCustomFieldsDataArr((prevState) => ({
          //   ...prevState,
          //   [index]: {
          //     ...prevState.index,
          //     [fieldName]: { value: value, label: fieldName }
          //   }
          // }));
        } else {
          // alert("x");

          mainobj = checksDetails[0].customFieldsDataArr.reference;

          // console.log("pp",checksDetails[0].customFieldsDataArr.reference);

          // setCustomFieldsDataArr(checksDetails[0].customFieldsDataArr.reference);

          // console.log("x",customFieldsDataArr)
        }

        if (typeof mainobj != "undefined") {
          setCustomFieldsDataArr(mainobj);
        } else {
          setCustomFieldsDataArr(customFieldsDataArr);
        }

        // alert(JSON.stringify(mainobj));

        console.log("mm", mainobj);
      }

      let obj = {};
      for (var i in docmentTypeData) {
        obj[docmentTypeData[i].DOCUMENT_ID] = docmentTypeData[i].DOCUMENT_TP;
      }
      setDocmentTypeOptions(obj);

      let objm = {};
      for (var i in docmentTypeData) {
        objm[parseInt(docmentTypeData[i].DOCUMENT_ID)] = parseInt(
          docmentTypeData[i].IS_MANDATORY
        );
      }
      setDocmentTypeOptionsMand({ 0: objm });

      console.log("ppt",docmentTypeAddressOptionsMand);

      // alert(JSON.stringify(docmentTypeOptionsMand['16']));//s

      let obj1 = {};
      for (var i in docmentTypeAddressData) {
        obj1[docmentTypeAddressData[i].DOCUMENT_ID] =
          docmentTypeAddressData[i].DOCUMENT_TP;
      }
      setDocmentTypeAddressOptions(obj1);

      let obj1m = {};
      for (var i in docmentTypeAddressData) {
        obj1m[docmentTypeAddressData[i].DOCUMENT_ID] =
          docmentTypeAddressData[i].IS_MANDATORY;
      }
      setDocmentTypeAddressOptionsMand({ 0: obj1m });

      const till =
        checksDetails[0].fields.till_date.field_value === "checked"
          ? true
          : false;
      let updatedtill = _.cloneDeep(till);
      updatedtill = till;

      setTillDateChecked({ 0: updatedtill });

      // const india = checksDetails[0].fields.address_belongs_to.field_value === "Within India" ? true : false;
      // let updatedIndia = _.cloneDeep(isIndia);
      // updatedIndia[0] = india;
      // setIsIndia(updatedIndia);
      // const ssn = checksDetails[0].fields.country.field_value == 2 ? true : false;
      // let updatedSsn = _.cloneDeep(ssn);
      // updatedSsn = ssn;
      // setIsSsn(updatedSsn);
      getUploadedFilesCount(checksDetails);
      getUploadedFilesCountField(checksDetails);
      //  alert(JSON.stringify(uploadedFilesCount))
    }
  }, [pv]);

  const getUploadedFilesCountField = (checksDetails) => {
    let uploadedFilesCount = {};

    for (let i in checksDetails) {
      let obj = [];

      let front = 1;
      let back = 1;

      for (let k in checksDetails[i].uploaded_documents) {
        if (
          typeof checksDetails[i].uploaded_documents[k].field_id !==
          "undefined" &&
          checksDetails[i].uploaded_documents[k].field_id !== null
        ) {
          obj[`${checksDetails[i].uploaded_documents[k].field_id}`] = {};
        }
      }

      for (let k in checksDetails[i].uploaded_documents) {
        if (
          typeof checksDetails[i].uploaded_documents[k].field_id !==
          "undefined" &&
          checksDetails[i].uploaded_documents[k].field_id !== null
        ) {
          obj[`${checksDetails[i].uploaded_documents[k].field_id}`][
            `${checksDetails[i].uploaded_documents[k].document_id}`
          ] = { front: 0, back: 0 };
        }
      }

      for (let k in checksDetails[i].uploaded_documents) {
        //let values = Object.entries(obj);

        //console.log("values", values);

        if (
          typeof checksDetails[i].uploaded_documents[k].field_id !==
          "undefined" &&
          checksDetails[i].uploaded_documents[k].field_id !== null
        ) {
          // console.log("kk7",checksDetails[i].uploaded_documents[k].document_id);

          //  obj[`${checksDetails[i].uploaded_documents[k].field_id}`][`${checksDetails[i].uploaded_documents[k].document_id}`] =  { "front": 0, "back": 0 }

          if (checksDetails[i].uploaded_documents[k].doc_side === "back") {
            obj[`${checksDetails[i].uploaded_documents[k].field_id}`][
              `${checksDetails[i].uploaded_documents[k].document_id}`
            ]["back"]++;
          } else if (
            checksDetails[i].uploaded_documents[k].doc_side === "front" ||
            checksDetails[i].uploaded_documents[k].doc_side == ""
          ) {
            obj[`${checksDetails[i].uploaded_documents[k].field_id}`][
              `${checksDetails[i].uploaded_documents[k].document_id}`
            ]["front"]++;
          }

          // alert(values)
          // if (values.includes(checksDetails[i].uploaded_documents[k].field_id.toString()) === true) {

          //   if (typeof obj[`${checksDetails[i].uploaded_documents[k].field_id}`] !== 'undefined') {

          //     let output1 = obj[`${checksDetails[i].uploaded_documents[k].field_id}`].hasOwnProperty([`${checksDetails[i].uploaded_documents[k].document_id}`]);

          //     if (output1) {

          //       // obj[`${checksDetails[i].uploaded_documents[k].document_id}`]++;
          //       // console.log("ff", checksDetails[i].uploaded_documents[k].doc_side);

          //       if (checksDetails[i].uploaded_documents[k].doc_side === 'back') {
          //         obj[`${checksDetails[i].uploaded_documents[k].field_id}`][`${checksDetails[i].uploaded_documents[k].document_id}`]['back']++
          //       } else if (checksDetails[i].uploaded_documents[k].doc_side === 'front' || checksDetails[i].uploaded_documents[k].doc_side == '') {
          //         obj[`${checksDetails[i].uploaded_documents[k].field_id}`][`${checksDetails[i].uploaded_documents[k].document_id}`]['front']++
          //       }

          //       // obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = { "front": front, "back": back };

          //     }else{

          //     }
          //   } else {

          //     if (checksDetails[i].uploaded_documents[k].doc_side == 'back') {

          //  //     obj[`${checksDetails[i].uploaded_documents[k].field_id}`] = { [`${checksDetails[i].uploaded_documents[k].document_id}`]: { "front": 0, "back": 1 } };

          //     } else if (checksDetails[i].uploaded_documents[k].doc_side == 'front' || checksDetails[i].uploaded_documents[k].doc_side == '') {

          //       obj[`${checksDetails[i].uploaded_documents[k].field_id}`] = { [`${checksDetails[i].uploaded_documents[k].document_id}`]: { "front": 1, "back": 0 } };

          //       //  debugger
          //     }

          //     //  obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = 1;
          //   }
        }
      }

      uploadedFilesCount[i] = obj;
    }

    console.log("kk", uploadedFilesCount);

    setUploadedFilesCountField(uploadedFilesCount);
  };

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};

      let front = 1;
      let back = 1;

      for (let k in checksDetails[i].uploaded_documents) {
        let values = Object.keys(obj);
        // alert(values)
        if (
          values.includes(
            checksDetails[i].uploaded_documents[k].document_id.toString()
          ) === true
        ) {
          // obj[`${checksDetails[i].uploaded_documents[k].document_id}`]++;
          // console.log("ff", checksDetails[i].uploaded_documents[k].doc_side);

          if (checksDetails[i].uploaded_documents[k].doc_side === "back") {
            obj[`${checksDetails[i].uploaded_documents[k].document_id}`][
              "back"
            ]++;
          } else if (
            checksDetails[i].uploaded_documents[k].doc_side === "front" ||
            checksDetails[i].uploaded_documents[k].doc_side == ""
          ) {
            obj[`${checksDetails[i].uploaded_documents[k].document_id}`][
              "front"
            ]++;
          }

          // obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = { "front": front, "back": back };
        } else {
          if (checksDetails[i].uploaded_documents[k].doc_side == "back") {
            obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = {
              front: 0,
              back: 1,
            };
          } else if (
            checksDetails[i].uploaded_documents[k].doc_side == "front" ||
            checksDetails[i].uploaded_documents[k].doc_side == ""
          ) {
            obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = {
              front: 1,
              back: 0,
            };
          }

          //  obj[`${checksDetails[i].uploaded_documents[k].document_id}`] = 1;
        }
      }

      uploadedFilesCount[i] = obj;
    }

    console.log("kk", uploadedFilesCount)

    setUploadedFilesCount(uploadedFilesCount);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  console.log("fr", errorData);
  return (
    <>
      {loading && <Loader />}
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {activeTab &&
            Object.keys(pv).length > 0 &&
            Object.entries(pv.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == index) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }
              let completeClass = "";
              if (caseCheckStatus === 2) {
                completeClass = "completed";
              }
              let check_name = value.IB_CHECK_NAME;
              return (
                <></>
                // <li className="nav-item" key={key}>
                //   <a
                //     className={`tab nav-link ${activeClass} ${completeClass}`}
                //     id={`pv-tab-${index}`}
                //     data-toggle="tab"
                //     href={`#pv-${index}`}
                //     role="tab"
                //     aria-controls={`pv-${index}`}
                //     aria-selected="true"
                //     data-index={index - 1}
                //     data-casecheckid={caseCheckId}
                //     //style={{ color: caseCheckStatus == 2 ? "green" : "grey" }}
                //   >
                //     {caseCheckStatus === 2 && (
                //       <i class="fas fa-check-circle mr-1"></i>
                //     )}
                //     {check_name}
                //   </a>
                // </li>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {pv.checksDetails &&
          Object.entries(pv.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            let activeClass = "";
            if (typeof active !== "undefined") {
              if (active == index) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }
            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`pv-${index}`}
                role="tabpanel"
                aria-labelledby={`pv-tab-${index}`}
                key={key}
              >
                {/* <div className="row" style={{marginBottom:'15px'}}>
                  {value.fields.address_belongs_to ? (
                    <PVRadio
                      name={`address_belongs_to_${caseCheckId}`}
                      id={`address_belongs_to_${caseCheckId}`}
                      fieldId={value.fields.address_belongs_to.ibridge_field_id}
                      label={value.fields.address_belongs_to.label}
                      isRequired={value.fields.address_belongs_to.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.address_belongs_to.ibridge_field_id}`}
                      options={
                        value.fields.address_belongs_to.getFieldDisplay.optionArray
                          .options
                      }
                      handleRadioChange={handleRadioChange}
                      checkDetailsIndex={key}
                      fieldName={"address_belongs_to"}
                      fieldValue={value.fields.address_belongs_to.field_value}
                      hasError={errorData.address_belongs_to}
                    />
                  ) : (
                    <></>
                  )}
                </div> */}

                <div className="row">
                  {value.fields.pin_code ? (
                    <PVText
                      name={`pin_code_${caseCheckId}`}
                      id={`pin_code_${caseCheckId}`}
                      fieldId={value.fields.pin_code.ibridge_field_id}
                      label={value.fields.pin_code.label}
                      isRequired={value.fields.pin_code.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.pin_code.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"pin_code"}
                      fieldValue={value.fields.pin_code.field_value}
                      hasError={errorData.pin_code}
                      customMsg={errorDataCustom["pin"]}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.city ? (
                    <PVText
                      name={`city_${caseCheckId}`}
                      id={`city_${caseCheckId}`}
                      fieldId={value.fields.city.ibridge_field_id}
                      label={value.fields.city.label}
                      isRequired={value.fields.city.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.city.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"city"}
                      fieldValue={value.fields.city.field_value}
                      hasError={errorData.city}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="row">
                  {value.fields.location ? (
                    <>
                      <PVSelectState
                        name={`location_${caseCheckId}`}
                        id={`location_${caseCheckId}`}
                        errId={`err_${caseCheckId}_${value.fields.location.ibridge_field_id}`}
                        label={value.fields.location.label}
                        autoComplete="off"
                        options={state}
                        isRequired={value.fields.location.is_mandatory}
                        caseCheckId={caseCheckId}
                        handleSelectChange={handleSelectChange}
                        checkDetailsIndex={key}
                        fieldName={"location"}
                        fieldValue={value.fields.location.field_value}
                        // hasError={errorData[index - 1]['location']}
                        hasError={errorData.location}
                        isReadOnly={continueButton == "1" ? true : false}
                      />
                      <input
                        type="hidden"
                        name={`stateverificationsrc_${caseCheckId}`}
                        id={`stateverificationsrc_${caseCheckId}`}
                        value={value.fields.location.field_value}
                      />
                      <input
                        type="hidden"
                        name={`stateverificationsrclabel_${caseCheckId}`}
                        id={`stateverificationsrclabel_${caseCheckId}`}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {/* {value.fields.location ? (
                  <PVText
                    name={`location_${caseCheckId}`}
                    id={`location_${caseCheckId}`}
                    fieldId={value.fields.location.ibridge_field_id}
                    label={value.fields.location.label}
                    isRequired={value.fields.location.is_mandatory}
                    errId={`err_${caseCheckId}_${value.fields.location.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={key}
                    fieldName={"location"}
                    fieldValue={value.fields.location.field_value}
                    hasError={errorData.location}
                  />
                ) : (
                  <></>
                )} */}

                  {value.fields.police_station ? (
                    <PVText
                      name={`police_station_${caseCheckId}`}
                      id={`police_station_${caseCheckId}`}
                      fieldId={value.fields.police_station.ibridge_field_id}
                      label={value.fields.police_station.label}
                      isRequired={value.fields.police_station.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"police_station"}
                      fieldValue={value.fields.police_station.field_value}
                      hasError={errorData.police_station}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.landmark_additional_address ? (
                    <PVText
                      name={`landmark_additional_address_${caseCheckId}`}
                      id={`landmark_additional_address_${caseCheckId}`}
                      fieldId={
                        value.fields.landmark_additional_address
                          .ibridge_field_id
                      }
                      label={value.fields.landmark_additional_address.label}
                      isRequired={
                        value.fields.landmark_additional_address.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.landmark_additional_address.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"landmark_additional_address"}
                      fieldValue={
                        value.fields.landmark_additional_address.field_value
                      }
                      hasError={errorData.landmark_additional_address}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.country && isIndia[0] === false ? (
                    <PVSelect
                      name={`country_${caseCheckId}`}
                      id={`country_${caseCheckId}`}
                      label={value.fields.country.label}
                      autoComplete="off"
                      options={countries}
                      isRequired={value.fields.country.is_mandatory}
                      caseCheckId={caseCheckId}
                      handleSelectChange={handleSelectChange}
                      checkDetailsIndex={key}
                      fieldName={"country"}
                      fieldValue={value.fields.country.field_value}
                      hasError={errorData.country}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                  {/* {value.fields.ssn && isSsn === true ? (
                  <PVText
                    name={`ssn_${caseCheckId}`}
                    id={`ssn_${caseCheckId}`}
                    fieldId={value.fields.ssn.ibridge_field_id}
                    label={value.fields.ssn.label}
                    //isRequired={value.fields.ssn.is_mandatory}
                    idRequired={
                      noSsnChecked[0] == true ? 0 : value.fields.ssn.is_mandatory
                    }
                    errId={`err_${caseCheckId}_${value.fields.ssn.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={key}
                    fieldName={"ssn"}
                    fieldValue={value.fields.ssn.field_value}
                    hasError={errorData.ssn}
                  />
                ) : (
                  <></>
                )} */}
                  {/* {value.fields.ssn && isSsn === true ? (
                  <PVCheckbox
                    name={`no_ssn_${caseCheckId}`}
                    id={`no_ssn_${caseCheckId}`}
                    fieldId={'no_ssn'}
                    label={'Not Applicable'}
                    //isRequired={0}
                    fieldValue={
                      noSsnChecked[0] == true ? 'checked' : ''
                    }
                    handleCheckboxChange={handleCheckboxChange}
                    checkDetailsIndex={key}
                    fieldName={"no_ssn"}
                  />
                ) : (
                  <></>
                )} */}
                </div>

                <div className="row">
                  {/* {value.fields.address ? (
                    <PVText
                      name={`address_${caseCheckId}`}
                      id={`address_${caseCheckId}`}
                      fieldId={value.fields.address.ibridge_field_id}
                      label={value.fields.address.label}
                      isRequired={value.fields.address.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.address.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"address"}
                      fieldValue={value.fields.address.field_value}
                      hasError={errorData.address}
                    />
                  ) : (
                    <></>
                  )} */}
                  {/* {value.fields.colony_street ? (
                    <PVText
                      name={`colony_street_${caseCheckId}`}
                      id={`colony_street_${caseCheckId}`}
                      fieldId={value.fields.colony_street.ibridge_field_id}
                      label={value.fields.colony_street.label}
                      isRequired={value.fields.colony_street.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.colony_street.ibridge_field_id}`}
                      handleTextChange={handleTextChange}
                      checkDetailsIndex={key}
                      fieldName={"colony_street"}
                      fieldValue={value.fields.colony_street.field_value}
                      hasError={errorData.colony_street}
                    />
                  ) : (
                    <></>
                  )} */}
                  {value.fields.residing_since ? (
                    <PVDate
                      paramStartDate={null}
                      placeholder={value.fields.residing_since.label}
                      name={`residing_since_${caseCheckId}`}
                      id={`residing_since_${caseCheckId}`}
                      fieldId={value.fields.residing_since.ibridge_field_id}
                      label={value.fields.residing_since.label}
                      isRequired={value.fields.residing_since.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.residing_since.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      fieldName={"residing_since"}
                      fieldValue={value.fields.residing_since.field_value}
                      hasError={errorData.residing_since}
                      maximumDate={value.fields.residing_from.field_value}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.residing_from &&
                    tillDateChecked[index - 1] === false ? (
                    <PVDate
                      paramStartDate={null}
                      placeholder={value.fields.residing_from.label}
                      name={`residing_from_${caseCheckId}`}
                      id={`residing_from_${caseCheckId}`}
                      fieldId={value.fields.residing_from.ibridge_field_id}
                      label={value.fields.residing_from.label}
                      isRequired={value.fields.residing_from.is_mandatory}
                      isDisabled={
                        tillDateChecked[index - 1] &&
                          tillDateChecked[index - 1] === true
                          ? true
                          : false
                      }
                      errId={`err_${caseCheckId}_${value.fields.residing_from.ibridge_field_id}`}
                      intialStatus={0}
                      saveDate={handleSaveDate}
                      checkDetailsIndex={key}
                      fieldName={"residing_from"}
                      fieldValue={value.fields.residing_from.field_value}
                      minimumDate={value.fields.residing_since.field_value}
                      hasError={errorData.residing_from}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.till_date ? (
                    <PVCheckbox
                      name={`till_date_${caseCheckId}`}
                      id={`till_date_${caseCheckId}`}
                      fieldId={value.fields.till_date.ibridge_field_id}
                      label={value.fields.till_date.label}
                      isRequired={value.fields.till_date.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`}
                      handleCheckboxChange={handleCheckboxChange}
                      checkDetailsIndex={key}
                      fieldName={"till_date"}
                      fieldValue={value.fields.till_date.field_value}
                      hasError={errorData.till_date}
                      isReadOnly={continueButton == "1" ? true : false}
                    />
                  ) : (
                    <></>
                  )}
                </div>

                {pvformRequired == 1 && (
                  <>
                    <p></p>
                    <br />

                    <PVSingleFileUpload
                      name="PV Form"
                      id="pv_form"
                      title="PV form"
                      record={{
                        caseCheckId: caseCheckId,
                        docId: 32,
                      }}
                      isRequired={1}
                      reRenderAgain2={reRenderAgain2}
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //   uploadedFilesCount[parseInt(index - 1)][
                      //     value.required_documents[0].id
                      //   ]
                      //     ? uploadedFilesCount[parseInt(index - 1)][
                      //         value.required_documents[0].id
                      //       ]
                      //     : 0
                      // }
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //     uploadedFilesCount[parseInt(index - 1)][32]
                      //     ? uploadedFilesCount[parseInt(index - 1)][32]
                      //     : 0
                      // }
                      totalCount={
                        uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][32]
                          ? uploadedFilesCount[parseInt(index - 1)][32]["front"]
                          : 0
                      }
                      // getCount={1}

                      // getUpdatedPvData={() => {
                      //   getUpdatedPvDataUp("pv");

                      // }}
                      errId={`err_${caseCheckId}_pv`}
                      // value={value}
                      getUpdatedPvData={() => {
                        getUpdatedPvDataUp("pv");
                      }}
                      hasError={errorData["pv"]}
                    />

                    <p></p>

                    <div className="row">
                      <div className="col-sm-4 col-md-12 col-xl-4">
                        <div className="upload-box">
                          <div className="left d-flex align-items-center">
                            <span>
                              <h6 className="m-0">Download PV Template</h6>
                            </span>
                          </div>
                          {console.log(
                            "fe",
                            pv.checksDetails[0].apiData.PV_FORM_HTTP_PATH
                          )}

                          {/* <Link to={pv.checksDetails[0].apiData.PV_FORM_HTTP_PATH}><img src={DownloadIcon} alt="" className="remove-btn" /></Link> */}
                          <a
                            target="_blank"
                            href={pv.checksDetails[0].apiData.PV_FORM_HTTP_PATH}
                            download="PV Form"
                          >
                            <img
                              src={DownloadIcon}
                              alt=""
                              className="remove-btn"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {idRequired == 1 && (
                  <>
                    <p></p>
                    <br />
                    <h6 className="fnt-smi-bld mb-0">ID Proof</h6>

                    <p></p>

                    <div className="row">
                      {value.fields.pv_id_proof ? (
                        <>
                          <PVSelect
                            name={`documentType_${caseCheckId}`}
                            id={`documentType_${caseCheckId}`}
                            label="Document Type"
                            autoComplete="off"
                            options={docmentTypeOptions}
                            isRequired={value.fields.pv_id_proof.is_mandatory}
                            caseCheckId={caseCheckId}
                            handleSelectChange={handleSelectChange}
                            ibFieldId={
                              value.fields.pv_id_proof.ibridge_field_id
                            }
                            checkDetailsIndex={key}
                            fieldName={"pv_id_proof"}
                            fieldValue={value.fields.pv_id_proof.field_value}
                            // hasError={errorData[index - 1]['location']}
                            errId={`err_${caseCheckId}_${value.fields.pv_id_proof.ibridge_field_id}`}
                            hasError={errorData.pv_id_proof}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </div>

                    {value.fields.pv_id_proof ? (
                      <>
                        <PVSingleFileUpload
                          name="ID Proof(Front)"
                          id="id_proof_front_uploader"
                          title="Front"
                          record={{
                            caseCheckId: caseCheckId,
                            // docId: value.fields.pv_id_proof.field_value,
                            docId: 35,
                            docside: "front",
                            fldid: value.fields.pv_id_proof.ibridge_field_id,
                          }}
                          reRenderAgain2={reRenderAgain2}
                          // isRequired={1}
                          isRequired={
                            docmentTypeOptionsMand[parseInt(index - 1)] &&
                              docmentTypeOptionsMand[parseInt(index - 1)][
                              value.fields.pv_id_proof.field_value
                              ]
                              ? docmentTypeOptionsMand[parseInt(index - 1)][
                              value.fields.pv_id_proof.field_value
                              ]
                              : 0
                          }
                          totalCount={
                            uploadedFilesCountField[parseInt(index - 1)] &&
                              uploadedFilesCountField[parseInt(index - 1)]
                                .length !== 0 &&
                              uploadedFilesCountField[
                                parseInt(index - 1)
                              ].hasOwnProperty(
                                value.fields.pv_id_proof.ibridge_field_id
                              ) &&
                              uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_id_proof.ibridge_field_id
                              ][35]
                              ? uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_id_proof.ibridge_field_id
                              ][35]["front"]
                              : 0
                          }
                          // totalCount={
                          //   uploadedFilesCount[parseInt(index - 1)] &&
                          //   uploadedFilesCount[parseInt(index - 1)][
                          //     value.required_documents[0].id
                          //   ]
                          //     ? uploadedFilesCount[parseInt(index - 1)][
                          //         value.required_documents[0].id
                          //       ]
                          //     : 0
                          // }
                          // getCount={1}

                          // getUpdatedPvData={getUpdatedPvData}
                          getUpdatedPvData={() => {
                            getUpdatedPvDataUp("id_proof_front");
                          }}
                          errId={`err_${caseCheckId}_id_proof_front_uploader`}
                          // value={value}
                          hasError={errorData["id_proof_front"]}
                        />

                        <PVSingleFileUpload
                          name="ID Proof(Back)"
                          id="id_proof_back_uploader"
                          title="Back"
                          record={{
                            caseCheckId: caseCheckId,
                            // docId: value.fields.pv_id_proof.field_value,
                            docId:35,
                            docside: "back",
                            fldid: value.fields.pv_id_proof.ibridge_field_id,
                          }}
                          reRenderAgain2={reRenderAgain2}
                          isRequired={
                            docmentTypeOptionsMand[parseInt(index - 1)] &&
                              docmentTypeOptionsMand[parseInt(index - 1)][
                              value.fields.pv_id_proof.field_value
                              ]
                              ? docmentTypeOptionsMand[parseInt(index - 1)][
                              value.fields.pv_id_proof.field_value
                              ]
                              : 0
                          }


                          totalCount={
                            uploadedFilesCountField[parseInt(index - 1)] &&
                              uploadedFilesCountField[parseInt(index - 1)]
                                .length !== 0 &&
                              uploadedFilesCountField[
                                parseInt(index - 1)
                              ].hasOwnProperty(
                                value.fields.pv_id_proof.ibridge_field_id
                              ) &&
                              uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_id_proof.ibridge_field_id
                              ][35]
                              ? uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_id_proof.ibridge_field_id
                              ][35]["back"]
                              : 0
                          }


                          // totalCount={
                          //   uploadedFilesCountField[parseInt(index - 1)] &&
                          //     uploadedFilesCountField[parseInt(index - 1)]
                          //       .length !== 0 &&
                          //     uploadedFilesCountField[
                          //       parseInt(index - 1)
                          //     ].hasOwnProperty(
                          //       value.fields.pv_id_proof.ibridge_field_id
                          //     ) &&
                          //     uploadedFilesCountField[parseInt(index - 1)][
                          //     value.fields.pv_id_proof.ibridge_field_id
                          //     ][value.fields.pv_id_proof.field_value]
                          //     ? uploadedFilesCountField[parseInt(index - 1)][
                          //     value.fields.pv_id_proof.ibridge_field_id
                          //     ][value.fields.pv_id_proof.field_value]["back"]
                          //     : 0
                          // }
                          // totalCount={
                          //   uploadedFilesCount[parseInt(index - 1)] &&
                          //   uploadedFilesCount[parseInt(index - 1)][
                          //     value.required_documents[0].id
                          //   ]
                          //     ? uploadedFilesCount[parseInt(index - 1)][
                          //         value.required_documents[0].id
                          //       ]
                          //     : 0
                          // }
                          getCount={1}
                          // getUpdatedPvData={getUpdatedPvData}
                          getUpdatedPvData={() => {
                            getUpdatedPvDataUp("id_proof_back");
                          }}
                          errId={`err_${caseCheckId}_id_proof_back_uploader`}
                          hasError={errorData["id_proof_back"]}
                        />
                      </>
                    ) : (
                      <></>
                    )}

                    {/* const [referenceRequired, setReferenceRequired] = useState({});
  const [referenceCount, setReferenceCount] = useState({});
  const [referenceConf, setReferenceConf] = useState({}); */}
                  </>
                )}

                {addressproofRequired == 1 && (
                  <>
                    <p></p>
                    <br />
                    <div className="d-flex">

                      <h6 className="fnt-smi-bld mb-0 mr-1">Address Proof </h6>
                      <small>
                        (Period of Stay in the given address should be minimum 6
                        months)
                      </small>
                      {/* {pv.companyId === 3231 ? <>  <h6 className="fnt-smi-bld mb-0 mr-1">Please provide permanent address proof</h6>
                      </> : <><h6 className="fnt-smi-bld mb-0 mr-1">Address Proof </h6>
                        <small>
                          (Period of Stay in the given address should be minimum 6
                          months)
                        </small></>} */}
                    </div>
                    <span className="red-err">
                      Please provide address proof of the address for which the
                      details have been mentioned earlier (Police Station and
                      Period of stay)
                    </span>
                    <p></p>

                    <div className="row">
                      {value.fields.pv_address_proof ? (
                        <>
                          <PVSelect
                            name={`documentTypeAddress_${caseCheckId}`}
                            id={`documentTypeAddress_${caseCheckId}`}
                            label="Document Type"
                            autoComplete="off"
                            options={docmentTypeAddressOptions}
                            isRequired={
                              value.fields.pv_address_proof.is_mandatory
                            }
                            caseCheckId={caseCheckId}
                            handleSelectChange={handleSelectChange}
                            ibFieldId={
                              value.fields.pv_address_proof.ibridge_field_id
                            }
                            checkDetailsIndex={key}
                            fieldName={"pv_address_proof"}
                            fieldValue={
                              value.fields.pv_address_proof.field_value
                            }
                            // hasError={errorData[index - 1]['location']}
                            hasError={errorData.pv_address_proof}
                            errId={`err_${caseCheckId}_${value.fields.pv_address_proof.ibridge_field_id}`}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </div>

                    {value.fields.pv_address_proof ? (
                      <>
                        <PVSingleFileUpload
                          name="Address Proof(Front)"
                          id="address_proof_front_uploader"
                          title="Front"
                          record={{
                            caseCheckId: caseCheckId,
                            // docId: value.fields.pv_address_proof.field_value,
                            docId: 34,
                            docside: "front",
                            fldid:
                              value.fields.pv_address_proof.ibridge_field_id,
                          }}
                          reRenderAgain2={reRenderAgain2}
                          // totalCount={
                          //   uploadedFilesCount[parseInt(index - 1)] &&
                          //     uploadedFilesCount[parseInt(index - 1)][value.fields.pv_address_proof.field_value]
                          //     ? uploadedFilesCount[parseInt(index - 1)][value.fields.pv_address_proof.field_value]
                          //     : 0
                          // }
                          isRequired={
                            docmentTypeAddressOptionsMand[
                              parseInt(index - 1)
                            ] &&
                              docmentTypeAddressOptionsMand[parseInt(index - 1)][
                              value.fields.pv_address_proof.field_value
                              ]
                              ? docmentTypeAddressOptionsMand[
                              parseInt(index - 1)
                              ][value.fields.pv_address_proof.field_value]
                              : 0
                          }
                          totalCount={
                            uploadedFilesCountField[parseInt(index - 1)] &&
                              uploadedFilesCountField[parseInt(index - 1)]
                                .length !== 0 &&
                              uploadedFilesCountField[
                                parseInt(index - 1)
                              ].hasOwnProperty(
                                value.fields.pv_address_proof.ibridge_field_id
                              ) &&
                              uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_address_proof.ibridge_field_id
                              ][34]
                              ? uploadedFilesCountField[parseInt(index - 1)][
                              value.fields.pv_address_proof.ibridge_field_id
                              ][34][
                              "front"
                              ]
                              : 0
                          }
                          // totalCount={
                          //   uploadedFilesCount[parseInt(index - 1)] &&
                          //   uploadedFilesCount[parseInt(index - 1)][
                          //     value.required_documents[0].id
                          //   ]
                          //     ? uploadedFilesCount[parseInt(index - 1)][
                          //         value.required_documents[0].id
                          //       ]
                          //     : 0
                          // }
                          // getCount={1}
                          // getUpdatedPvData={getUpdatedPvData}
                          getUpdatedPvData={() => {
                            getUpdatedPvDataUp("address_proof_front");
                          }}
                          errId={`err_${caseCheckId}_address_proof_front_uploader`}
                          // value={value}
                          hasError={errorData["address_proof_front"]}
                        />

                        {selectedAddressProof != "2" &&
                          selectedAddressProof != "127" ? (
                          <>
                            <PVSingleFileUpload
                              name="Address Proof(Back)"
                              id="address_proof_back_uploader"
                              title="Back"
                              record={{
                                caseCheckId: caseCheckId,
                                // docId:
                                //   value.fields.pv_address_proof.field_value,
                                docId: 34,
                                docside: "back",
                                fldid:
                                  value.fields.pv_address_proof
                                    .ibridge_field_id,
                              }}
                              reRenderAgain2={reRenderAgain2}
                              // totalCount={
                              //   uploadedFilesCount[parseInt(index - 1)] &&
                              //     uploadedFilesCount[parseInt(index - 1)][value.fields.pv_address_proof.field_value]
                              //     ? uploadedFilesCount[parseInt(index - 1)][value.fields.pv_address_proof.field_value]
                              //     : 0
                              // }

                              isRequired={
                                docmentTypeAddressOptionsMand[
                                  parseInt(index - 1)
                                ] &&
                                  docmentTypeAddressOptionsMand[
                                  parseInt(index - 1)
                                  ][value.fields.pv_address_proof.field_value]
                                  ? docmentTypeAddressOptionsMand[
                                  parseInt(index - 1)
                                  ][value.fields.pv_address_proof.field_value]
                                  : 0
                              }
                              totalCount={
                                uploadedFilesCountField[parseInt(index - 1)] &&
                                  uploadedFilesCountField[parseInt(index - 1)]
                                    .length !== 0 &&
                                  uploadedFilesCountField[
                                    parseInt(index - 1)
                                  ].hasOwnProperty(
                                    value.fields.pv_address_proof.ibridge_field_id
                                  ) &&
                                  uploadedFilesCountField[parseInt(index - 1)][
                                  value.fields.pv_address_proof.ibridge_field_id
                                  ][34]
                                  ? uploadedFilesCountField[
                                  parseInt(index - 1)
                                  ][
                                  value.fields.pv_address_proof
                                    .ibridge_field_id
                                  ][34]["back"]
                                  : 0
                              }
                              // totalCount={
                              //   uploadedFilesCount[parseInt(index - 1)] &&
                              //   uploadedFilesCount[parseInt(index - 1)][
                              //     value.required_documents[0].id
                              //   ]
                              //     ? uploadedFilesCount[parseInt(index - 1)][
                              //         value.required_documents[0].id
                              //       ]
                              //     : 0
                              // }
                              // getCount={1}
                              // getUpdatedPvData={getUpdatedPvData}
                              getUpdatedPvData={() => {
                                getUpdatedPvDataUp("address_proof_back");
                              }}
                              errId={`err_${caseCheckId}_address_proof_back_uploader`}
                              // value={value}
                              hasError={errorData["address_proof_back"]}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}

                {letterRequired == 1 && (
                  <>
                    <p></p>
                    <br />

                    {/* <h6 className="fnt-smi-bld mb-0">Photo upload &nbsp;  <small class="fnt-inter-mdum">(Please upload Coloured, White Background, Passport size photo)</small></h6> */}
                    {/* <p class="text-muted">this is a test subheadubng</p> */}

                    <PVSingleFileUpload
                      name="companyLetter"
                      id="company_letter_upload"
                      title={value.fields.pv_request_letter.label}
                      record={{
                        caseCheckId: caseCheckId,
                        docId: 33,
                      }}
                      isRequired={value.fields.pv_request_letter.is_mandatory}
                      reRenderAgain2={reRenderAgain2}
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //   uploadedFilesCount[parseInt(index - 1)][
                      //     value.required_documents[0].id
                      //   ]
                      //     ? uploadedFilesCount[parseInt(index - 1)][
                      //         value.required_documents[0].id
                      //       ]
                      //     : 0
                      // }
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //     uploadedFilesCount[parseInt(index - 1)][33]
                      //     ? uploadedFilesCount[parseInt(index - 1)][33]
                      //     : 0
                      // }
                      totalCount={
                        uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][33]
                          ? uploadedFilesCount[parseInt(index - 1)][33]["front"]
                          : 0
                      }
                      // getCount={1}

                      // getUpdatedPvData={getUpdatedPvData}
                      // getUpdatedPvData={() => {
                      //   getUpdatedPvDataUp("cl");

                      // }}

                      errId={`err_${caseCheckId}_cl`}
                      // value={value}
                      getUpdatedPvData={() => {
                        getUpdatedPvDataUp("cl");
                      }}
                      hasError={errorData["cl"]}
                    />

                    <p></p>

                    {/* 
              <div className="row">

                <div className="col-sm-4 col-md-12 col-xl-4">
                  <div className="upload-box">
                    <div className="left d-flex align-items-center">
                      <span>
                        <h6 className="m-0">Download PV Template</h6>
                      </span>
                    </div>
                    <a href={pv.pv_template_url} download="PV Form"><img src={DownloadIcon} alt="" className="remove-btn" /></a>
                  </div>

                </div>


              </div> */}
                  </>
                )}

                {photoRequired == 1 && (
                  <>
                    <p></p>
                    <br />

                    {/* <h6 className="fnt-smi-bld mb-0">Photo upload &nbsp;  <small class="fnt-inter-mdum">(Please upload Coloured, White Background, Passport size photo)</small></h6> */}
                    {/* <p class="text-muted">this is a test subheadubng</p> */}

                    <PVSingleFileUpload
                      name="Photograph"
                      id="photo_upload"
                      //    title={value.fields.pv_photo_id_proof.label}
                      title="Photo Upload"
                      subheading="(Please upload Coloured, White Background, Passport size photo)"
                      record={{
                        caseCheckId: caseCheckId,
                        docId: 36,
                      }}
                      // isRequired={value.fields.pv_photo_id_proof.is_mandatory}
                      isRequired={1}
                      reRenderAgain2={reRenderAgain2}
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //   uploadedFilesCount[parseInt(index - 1)][
                      //     value.required_documents[0].id
                      //   ]
                      //     ? uploadedFilesCount[parseInt(index - 1)][
                      //         value.required_documents[0].id
                      //       ]
                      //     : 0
                      // }
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //     uploadedFilesCount[parseInt(index - 1)][36]
                      //     ? uploadedFilesCount[parseInt(index - 1)][36]
                      //     : 0
                      // }
                      totalCount={
                        uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][36]
                          ? uploadedFilesCount[parseInt(index - 1)][36]["front"]
                          : 0
                      }
                      // getCount={1}
                      // getUpdatedPvData={getUpdatedPvData}
                      errId={`err_${caseCheckId}_photograph_uploader`}
                      // value={value}
                      getUpdatedPvData={() => {
                        getUpdatedPvDataUp("photograph_uploader");
                      }}
                      hasError={errorData["photograph_uploader"]}
                    />

                    <p></p>

                    {/* 
              <div className="row">

                <div className="col-sm-4 col-md-12 col-xl-4">
                  <div className="upload-box">
                    <div className="left d-flex align-items-center">
                      <span>
                        <h6 className="m-0">Download PV Template</h6>
                      </span>
                    </div>
                    <a href={pv.pv_template_url} download="PV Form"><img src={DownloadIcon} alt="" className="remove-btn" /></a>
                  </div>

                </div>


              </div> */}
                  </>
                )}

                {affidavitRequired == 1 && (
                  <>
                    <p></p>
                    <br />

                    {/* <h6 className="fnt-smi-bld mb-0">Photo upload &nbsp;  <small class="fnt-inter-mdum">(Please upload Coloured, White Background, Passport size photo)</small></h6> */}
                    {/* <p class="text-muted">this is a test subheadubng</p> */}

                    <PVSingleFileUpload
                      name="Affidavit"
                      id="affidavit_upload"
                      // title={value.fields.pv_affidavit_proof.label}
                      title="Self-Declaration Affidavit"
                      record={{
                        caseCheckId: caseCheckId,
                        docId: 38,
                      }}
                      isRequired={1}
                      reRenderAgain2={reRenderAgain2}
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //   uploadedFilesCount[parseInt(index - 1)][
                      //     value.required_documents[0].id
                      //   ]
                      //     ? uploadedFilesCount[parseInt(index - 1)][
                      //         value.required_documents[0].id
                      //       ]
                      //     : 0
                      // }
                      // totalCount={
                      //   uploadedFilesCount[parseInt(index - 1)] &&
                      //     uploadedFilesCount[parseInt(index - 1)][38]
                      //     ? uploadedFilesCount[parseInt(index - 1)][38]
                      //     : 0
                      // }
                      totalCount={
                        uploadedFilesCount[parseInt(index - 1)] &&
                          uploadedFilesCount[parseInt(index - 1)][38]
                          ? uploadedFilesCount[parseInt(index - 1)][38]["front"]
                          : 0
                      }
                      // getCount={1}
                      // getUpdatedPvData={getUpdatedPvData}
                      getUpdatedPvData={() => {
                        getUpdatedPvDataUp("affidavit_uploader");
                      }}
                      errId={`err_${caseCheckId}_affidavit_uploader`}
                      // value={value}
                      hasError={errorData["affidavit_uploader"]}
                    />

                    <p></p>

                    <div className="row">
                      <div className="col-sm-4 col-md-12 col-xl-4">
                        <div className="upload-box">
                          <div className="left d-flex align-items-center">
                            <span>
                              <h6 className="m-0">
                                Download Affidavit Template
                              </h6>
                            </span>
                          </div>
                          {console.log(
                            "fe",
                            pv.checksDetails[0].apiData.AFFIDAVIT_HTTP_PATH
                          )}

                          {/* <Link to={pv.checksDetails[0].apiData.PV_FORM_HTTP_PATH}><img src={DownloadIcon} alt="" className="remove-btn" /></Link> */}
                          <a
                            target="_blank"
                            href={
                              pv.checksDetails[0].apiData.AFFIDAVIT_HTTP_PATH
                            }
                            download="Affidavit Template"
                          >
                            <img
                              src={DownloadIcon}
                              alt=""
                              className="remove-btn"
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* 
              <div className="row">

                <div className="col-sm-4 col-md-12 col-xl-4">
                  <div className="upload-box">
                    <div className="left d-flex align-items-center">
                      <span>
                        <h6 className="m-0">Download PV Template</h6>
                      </span>
                    </div>
                    <a href={pv.pv_template_url} download="PV Form"><img src={DownloadIcon} alt="" className="remove-btn" /></a>
                  </div>

                </div>


              </div> */}
                  </>
                )}

                {/* {JSON.stringify(errorData)} */}

                {referenceRequired == 1 && referenceConf != null && (
                  <>
                    <br />

                    <p></p>

                    {/* {Array.from(Array(referenceCount))} */}
                    {referenceCount > 0 &&
                      [...Array(parseInt(referenceCount))].map((e, i) => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-xl-12">
                                <h6 className="fnt-smi-bld mb-0">
                                  Reference {i + 1}
                                </h6>

                                <p></p>
                              </div>

                              {/* {i} */}

                              {referenceConf &&
                                Object.values(referenceConf).map(
                                  (key, valp) => {
                                    console.log("key..", key);
                                    console.log("value..", valp);
                                    return (
                                      <>
                                        {/* {key} */}
                                        {key == "Name" ? (
                                          <>
                                            <PVRefText
                                              index={valp}
                                              name={`reference_name_${caseCheckId}`}
                                              id={`reference_name_${caseCheckId}`}
                                              // fieldId={value.fields.police_station.ibridge_field_id}
                                              // label={value.fields.police_station.label}
                                              label="Name"
                                              isRequired={1}
                                              errId={`err_ref_name_${i + 1}`}
                                              handleTextChange={handleRefChange}
                                              checkDetailsIndex={i + 1}
                                              fieldName={"Name"}
                                              fieldValue={
                                                customFieldsDataArr[i + 1] !==
                                                null &&
                                                customFieldsDataArr[i + 1][
                                                  "Name"
                                                ].value
                                              }
                                              hasError={
                                                errorData[`ref_name_${[i + 1]}`]
                                              }
                                              customMsg={
                                                errorDataCustom[
                                                `ref_name_${[i + 1]}`
                                                ]
                                              }

                                            // hasError={errorData.police_station}
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}

                                        {key == "Address" ? (
                                          <>
                                            <PVRefText
                                              index={valp}
                                              name={`reference_address_${caseCheckId}`}
                                              id={`reference_address_${caseCheckId}`}
                                              // fieldId={value.fields.police_station.ibridge_field_id}
                                              // label={value.fields.police_station.label}
                                              label="Address"
                                              isRequired={1}
                                              errId={`err_ref_address_${i + 1}`}
                                              // errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                                              handleTextChange={handleRefChange}
                                              checkDetailsIndex={i + 1}
                                              fieldName={"Address"}
                                              fieldValue={
                                                customFieldsDataArr[i + 1] !==
                                                null &&
                                                customFieldsDataArr[i + 1][
                                                  "Address"
                                                ].value
                                              }
                                              hasError={
                                                errorData[
                                                `ref_address_${[i + 1]}`
                                                ]
                                              }
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}

                                        {/* {JSON.stringify(customFieldsDataArr)} */}

                                        {key == "Mob No." ? (
                                          <>
                                            <PVRefText
                                              index={valp}
                                              name={`reference_mob_${caseCheckId}`}
                                              id={`reference_mob_${caseCheckId}`}
                                              // fieldId={value.fields.police_station.ibridge_field_id}
                                              label="Mob No."
                                              isRequired={1}
                                              errId={`err_ref_mobile_${i + 1}`}
                                              // errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                                              handleTextChange={handleRefChange}
                                              checkDetailsIndex={i + 1}
                                              fieldName={"Mob No."}
                                              fieldValue={
                                                customFieldsDataArr[i + 1] !==
                                                null &&
                                                customFieldsDataArr[i + 1][
                                                  "Mob No."
                                                ].value
                                              }
                                              icon="mob"
                                              hasError={
                                                errorData[
                                                `ref_mob-no_${[i + 1]}`
                                                ]
                                              }
                                              customMsg={
                                                errorDataCustom[
                                                `ref_mob-no_${[i + 1]}`
                                                ]
                                              }
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}

                                        {key == "Police Station" ? (
                                          <>
                                            <PVRefText
                                              index={valp}
                                              name={`reference_police_${caseCheckId}`}
                                              id={`reference_police_${caseCheckId}`}
                                              // fieldId={value.fields.police_station.ibridge_field_id}
                                              label="Police Station"
                                              isRequired={1}
                                              errId={`err_ref_police_${i + 1}`}
                                              // errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                                              handleTextChange={handleRefChange}
                                              checkDetailsIndex={i + 1}
                                              fieldName={"Police Station"}
                                              fieldValue={
                                                customFieldsDataArr[i + 1] !==
                                                null &&
                                                customFieldsDataArr[i + 1][
                                                  "Police Station"
                                                ].value
                                              }
                                              // hasError={errorData[`ref_Police Station_${[i + 1]}`]}
                                              hasError={
                                                errorData[
                                                  `ref_police-station_${[
                                                    i + 1,
                                                  ]}`
                                                ]
                                                  ? errorData[
                                                  `ref_police-station_${[
                                                    i + 1,
                                                  ]}`
                                                  ]
                                                  : ""
                                              }
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}

                                        {key ==
                                          "Relationship with candidate" ? (
                                          <>
                                            <PVRefSelect
                                              index={valp}
                                              name={`reference_rel_${caseCheckId}`}
                                              id={`reference_rel_${caseCheckId}`}
                                              label="Relationship with candidate"
                                              autoComplete="off"
                                              options={relationOption}
                                              isRequired={1}
                                              caseCheckId={caseCheckId}
                                              handleSelectChange={
                                                handleRefChange
                                              }
                                              checkDetailsIndex={i + 1}
                                              fieldName={
                                                "Relationship with candidate"
                                              }
                                              fieldValue={
                                                customFieldsDataArr[i + 1] !==
                                                null &&
                                                customFieldsDataArr[i + 1][
                                                  "Relationship with candidate"
                                                ].value
                                              }
                                              hasError={
                                                errorData[
                                                  `ref_relationship-with-candidate_${[
                                                    i + 1,
                                                  ]}`
                                                ]
                                                  ? errorData[
                                                  `ref_relationship-with-candidate_${[
                                                    i + 1,
                                                  ]}`
                                                  ]
                                                  : ""
                                              }
                                              errId={`err_ref_relation_${i + 1
                                                }`}
                                            />
                                          </>
                                        ) : (
                                          <></>
                                        )}

                                        {/* {key == "Relationship with candidate" ? (
                                    <PVRefText
                                      index={valp}
                                      name={`reference_rel_${caseCheckId}`}
                                      id={`reference_rel_${caseCheckId}`}
                                      // fieldId={value.fields.police_station.ibridge_field_id}
                                      label="Relationship with candidate"
                                      isRequired={1}
                                      errId={`err_ref_relation_${i + 1}`}
                                      // errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                                      handleTextChange={handleRefChange}
                                      checkDetailsIndex={i + 1}
                                      fieldName={"Relationship with candidate"}
                                      fieldValue={customFieldsDataArr[i + 1] !== null && customFieldsDataArr[i + 1]["Relationship with candidate"].value}
                                      hasError={errorData[`ref_Relationship with candidate_${[i + 1]}`]}
                                    />

                                  ) : (
                                    <></>
                                  )} */}
                                      </>
                                    );
                                  }
                                )}
                            </div>
                          </>
                        );
                      })}

                    {/* <div className="row">
              
                {value.fields.police_station ? (
                  <PVText
                    name={`police_station_${caseCheckId}`}
                    id={`police_station_${caseCheckId}`}
                    fieldId={value.fields.police_station.ibridge_field_id}
                    label={value.fields.police_station.label}
                    isRequired={value.fields.police_station.is_mandatory}
                    errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                    handleTextChange={handleTextChange}
                    checkDetailsIndex={key}
                    fieldName={"police_station"}
                    fieldValue={value.fields.police_station.field_value}
                    hasError={errorData.police_station}
                  />
                ) : (
                  <></>
                )}

              </div> */}
                  </>
                )}

                <div className="row mt-3">
                  <div className="col-md-12">
                    <span className="red-err">
                      <span style={{ fontWeight: "bold" }}>Please Note</span>:
                      You need to visit Police Station for verification purpose
                      if summoned
                    </span>
                  </div>
                  <div className="col-auto d-flex justify-content-between pv_save">
                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                    Back
                  </button> */}

                    {/* {continueButton} */}

                    {continueButton != "1" ? (
                      <>
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3 mr-2"
                          onClick={(e) => updateHandler(e, caseCheckId, index)}
                        >
                          Update
                        </button>
                      </>
                    ) : (
                      <></>
                    )}

                    {continueButton == "1" ? (
                      <>
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => saveHandler(e, caseCheckId, index)}
                        >
                          Save
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {pv.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MainForm;
